export default __webpack_public_path__ + "images/9C.dd7b0e1.png";